/*
 * Copyright (c) 2016-present, Parse, LLC
 * All rights reserved.
 *
 * This source code is licensed under the license found in the LICENSE file in
 * the root directory of this source tree.
 */
import * as AJAX         from 'lib/AJAX';
import keyMirror         from 'lib/keyMirror';
import Parse             from 'parse';
import { Map, List }     from 'immutable';
import { registerStore } from 'lib/stores/StoreManager';

export const ActionTypes = keyMirror([
  'FETCH',
  'CREATE',
  'EDIT',
  'DELETE',
  'ACTIVATE',
]);

// Jobs state should be an Immutable Map with the following fields:
//   - lastFetch: the last time all data was fetched from the server
//   - jobs: An Immutable Map of schedule ids to Maps of job details

function JobsStore(state, action) {
  // let endpoint = (action.app.serverInfo || {}).parseServerVersion == '2.2.23' ? 'job' : 'jobs';
  let endpoint = 'job'

  let path = '';
  switch (action.type) {
    case ActionTypes.FETCH:
      if (state && new Date() - state.get('lastFetch') < 60000) {
        return Promise.resolve(state);
      }

      // return action.app.apiRequest('GET', 'job', {/* objectId: action.jobId */}, { useMasterKey: true }).then((result) =>
      return action.app.apiRequest('GET', endpoint, {/* objectId: action.jobId */}, { useMasterKey: true }).then((result) =>
      {

        var jobs = result.jobs.map(i =>
        {
          var params = JSON.stringify(i.data)
          if(params == '{}'){ params = '' }

          return {
            params,
            objectId     : i._id,
            jobName      : i.name,
            description  : i.description,
            startAfter   : i.startAfter,
            repeatMinutes: parseInt(i.repeatInterval),
            daysOfWeek   : [1,1,1,1,1,1,1],
            timeOfDay    : i.repeatAt,
            lastRun      : i.lastRunAt,
            // running      : !!i.lockedAt,
            inactive     : !!i.jobName,
          }
        })

        return Map({ lastFetch: new Date(), jobs: List(jobs) });
      })

    case ActionTypes.CREATE:

      // params: { "my_param": 123 }

      // ... schedule / repeat

      // description: :my fancy description
      // jobName: :userMigration
      // startAfter: :2016-08-25T10:53:00.000Z
      // timeOfDay: :12:02:00.000Z
      // repeatMinutes: :180

      // return action.app.apiRequest('POST', 'job/schedule', action.schedule, { useMasterKey: true }).then((result) =>
      return action.app.apiRequest('POST', endpoint + '/schedule', action.schedule, { useMasterKey: true }).then((result) =>
      {
        let { ...schedule } = action.schedule;
        schedule.objectId = result.objectId;
        schedule.startAfter = schedule.startAfter || new Date().toISOString();

        return state.set('jobs', state.get('jobs').push(schedule));
      });
    case ActionTypes.EDIT:
      // path = `/apps/${action.app.slug}/cloud_code/jobs/${action.jobId}`;
      // return AJAX.put(path, action.updates).then(() => {

      action.schedule.objectId = action.jobId
      return action.app.apiRequest('POST', endpoint + '/schedule', action.schedule, { useMasterKey: true }).then(() =>
      {
        let index = state.get('jobs').findIndex((j) => j.objectId === action.jobId);
        let current = state.get('jobs').get(index);
        let { ...schedule } = action.schedule;
        schedule.objectId = current.objectId;
        schedule.timeOfDay = schedule.timeOfDay || current.timeOfDay;
        return state.set('jobs', state.get('jobs').set(index, schedule));
      });
    case ActionTypes.DELETE:
      // path = `/apps/${action.app.slug}/cloud_code/jobs/${action.jobId}`;
      // return AJAX.del(path)
      return action.app.apiRequest('DELETE', endpoint, { objectId: action.jobId }, { useMasterKey: true })
      .then(() =>
      {
        let index = state.get('jobs').findIndex((j) => j.objectId === action.jobId);
        return state.set('jobs', state.get('jobs').delete(index));
      }, () => state);

    case ActionTypes.ACTIVATE:
      // path = `/apps/${action.app.slug}/cloud_code/jobs/${action.jobId}`;
      // return AJAX.del(path)
      return action.app.apiRequest('POST', endpoint + '/activate', { objectId: action.jobId }, { useMasterKey: true }).then((result) =>
      {
        let index = state.get('jobs').findIndex((j) => j.objectId === action.jobId);
        let current = state.get('jobs').get(index);

        let params = JSON.stringify(result.schedule.data)
        if(params == '{}'){ params = '' }

        let { ...schedule } = {
            params,
            objectId     : result.schedule._id,
            jobName      : result.schedule.name,
            description  : result.schedule.description,
            startAfter   : result.schedule.startAfter,
            repeatMinutes: parseInt(result.schedule.repeatInterval),
            daysOfWeek   : [1,1,1,1,1,1,1],
            timeOfDay    : result.schedule.repeatAt,
            lastRun      : result.schedule.lastRunAt,
            inactive     : !!result.schedule.jobName,
          };

        schedule.objectId = current.objectId;
        schedule.timeOfDay = schedule.timeOfDay || current.timeOfDay;
        return state.set('jobs', state.get('jobs').set(index, schedule));
      });
  }
}

registerStore('Jobs', JobsStore);
